import React from 'react';
import Hero from '../components/Hero';
import Strip from '../components/Strip';
import Catalog from '../components/Catalog';
import Network from '../components/Network';
import Network2 from '../components/Network2';
// import Partners from '../components/Partners';
import Contact from '../components/Contact';
import Cta from '../components/Cta';
import FAQ from '../components/FAQ';

type HomeProps = {
  onNavigate: (href: string) => void;
};

function Home({ onNavigate }: HomeProps) {
  return (
    <>
      <Hero onNavigate={onNavigate} />
      <Strip />
      <Catalog limit={5} onViewFull={() => onNavigate('/catalog')} />
      <Network />
      <Network2 />
      {/*<Partners />*/}
      <FAQ />
      <Cta onNavigate={onNavigate} />
      <Contact />
    </>
  );
}

export default Home;
